/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import Select from 'react-select'
import {Checkbox, message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class CustomerIo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      refType: 'CUSTOMER',
      providerId: '',
      loading: false,
      Io: [],
      printInfo: [],
      selectedDateTo: null,
      lengthCardex: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      manual: true,
      providers: [],
      selectedOption: [],
      wareHousesname: [],
      wareType: [],
      fromDate: '',
      toDate: '',
      buttonClicked: false,
      wareTextPrint: '',
      wareText: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: ' بارکد محصول',
          value: 'productCode',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'موجودی از قبل',
          value: 'remain',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'وارد شده',
          value: 'inQuantity',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'خارج شده',
          value: 'productCode',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'مانده',
          value: 'remainQuantity',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'تامین کننده کالا',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      aggregation: {},
      remainSum: 0,
      totalInQuantity: 0,
      totalOutQuantity: 0,
      manualDateMin: '',
      manualDateMax: '',
      confirmDateMin: '',
      confirmDateMax: ''
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeWarehouse(e) {
    let target = e.target
    this.setState({
      wareText: target.options[target.selectedIndex].text
    })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(selectedOption)

    console.log(`Option selected:`, selectedOption)
  }

  componentDidMount() {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        response.data.object.forEach((item) => {
          item.value = item.id
          item.label = item.id + ' - ' + item.name + ' - ' + item.typePrimaryName
        })
        this.setState({
          wareHousesname: response.data.object
        })
      })
      .catch((error) => {
        console.log(error)
      })

    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] = result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch((error) => {
    //     alert(JSON.stringify(error));
    //   });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllwarehouseIO(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllwarehouseIO(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllwarehouseIO(false)
    }
  }

  getAllwarehouseIO = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    return http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_FLOW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              Io: response.data.object.result,
              lengthCardex: response.data.object.countAll,
              buttonClicked: true,
              wareTextPrint: this.state.wareText,
              loading: false
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
          // message.error(
          //   "خطای " +
          //     response.data.errorCode +
          //     " : " +
          //     response.data.description
          // );
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  onResultFetched(data) {
    this.setState({
      Io: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Io: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeManual(e) {
    let name = e.target.name
    const target = e.target

    this.setState({
      [name]: target.type == 'checkbox' ? target.checked : target.value
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let {manual, manualDateMin, manualDateMax, confirmDateMin, confirmDateMax} = this.state
    let articleId = this.convertDigit(document.getElementById('articleId').value)
    let productName = document.getElementById('productName').value
    let typeWarehouseId = this.state.typeWarehouseId ? this.state.typeWarehouseId.id : ''
    let providerId = this.state.providerId
    let productCode = document.getElementById('productCode').value
    let typePrimary = document.getElementById('typePrimary').value
    let bigger = document.getElementById('bigger').value

    let isInternal = false
    let isAutomatic = document.getElementById('isAutomatic').value

    let refType = 'CUSTOMER'
    // let refTypePrimaryWarehouseId = document.getElementById(
    //   "refTypePrimaryWarehouseId"
    // ).value;
    let refFactorNo = document.getElementById('refFactorNo').value
    let refCustomerId = document.getElementById('refCustomerId').value
    let refTypeWarehouseId = this.state.refTypeWarehouseId ? this.state.refTypeWarehouseId.id : ''
    let refProviderId = this.state.refProviderId

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (articleId !== '' && articleId.length) {
      filter.articleId = articleId.trim()
    }
    if (productName !== '' && productName.length) {
      filter.productName = productName.trim()
    }
    if (productCode !== '') {
      filter.productCode = productCode.trim()
    }
    if (typeWarehouseId) {
      filter.typeWarehouseId = typeWarehouseId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (typePrimary !== '' && typePrimary.length) {
      filter.typePrimary = typePrimary
    }

    if (isAutomatic !== '') {
      filter.isAutomatic = isAutomatic
    }
    if (isInternal !== '') {
      filter.isInternal = isInternal
    }
    if (manualDateMin) {
      filter.manualDateMin = manualDateMin
    }
    if (manualDateMax) {
      filter.manualDateMax = manualDateMax
    }
    if (confirmDateMin) {
      filter.confirmDateMin = confirmDateMin
    }
    if (confirmDateMax) {
      filter.confirmDateMax = confirmDateMax
    }
    if (refType !== '') {
      filter.refType = refType
    }
    // if (refTypePrimaryWarehouseId) {
    //   filter.refTypePrimaryWarehouseId = refTypePrimaryWarehouseId;
    // }
    if (refTypeWarehouseId) {
      filter.refTypeWarehouseId = refTypeWarehouseId
    }
    if (refFactorNo) {
      filter.refFactorNo = refFactorNo
    }

    if (refProviderId) {
      filter.refProviderId = refProviderId
    }
    if (refCustomerId) {
      filter.refCustomerId = refCustomerId
    }

    if (bigger) {
      filter.bigger = bigger
    }

    return filter
  }

  getAggregation = (exportStatus) => {
    const filter = this.createFilter(exportStatus)
    delete filter.sortBy
    this.setState({loading: true})
    return http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_FLOW}/aggregated`, {
        params: filter
      })
      .then((res) => {
        this.setState({
          loading: false
        })
        if (res.data.error === null) {
          this.setState({
            totalInQuantity: res.data.object.result[0].inQuantity,
            totalOutQuantity: res.data.object.result[0].outQuantity,
            remainSum: res.data.object.result[0].remainSum
          })
        } else {
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAllwarehouseIO(false).then(() => {
            this.getAggregation(false)
          })
        }
      )
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getPrintInfo = () => {
    this.getAllwarehouseIO(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_FLOW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['mandeh'] =
              excelReport[i]['remain'] + excelReport[i]['inQuantity'] - excelReport[i]['outQuantity']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  dynamicBreadTitle = () => {
    let urlParams = new URLSearchParams(window.location.search)
    let from = !urlParams.get('from') ? '' : urlParams.get('from')
    if (!from) return ''
    else if (from === 'inventory') return <li>انبار</li>
    else return <li>مالی</li>
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    const {selectedOption} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')

    let excelColumns = [
      {title: 'تاریخ ثبت', value: 'confirmDate'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'تعداد وارد شده', value: 'inQuantity'},
      {title: 'تعداد خارج شده', value: 'outQuantity'},
      {title: 'شماره پیش سند', value: 'preWarehouseDocId'},
      {title: 'شماره سند', value: 'natureDocNo'},
      {title: 'تامین کننده کالا', value: 'providerName'}
    ]
    let columns = [
      'ردیف',
      'کد محصول',
      'بارکد محصول',
      'نام محصول',
      'موجودی از قبل',
      'وارد شده',
      'خارج شده',
      'مانده',
      'تامین کننده کالا'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش گردش انبار با مشتری"
              headerColSpan={9}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={4}
              centerColSpan={1}
              centerSection={''}
              rightSection={'موجودی برای انبار : ' + this.state.wareTextPrint}
              columns={columns}
            />

            <tbody>
              {this.state.printInfo.map((cardex, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{cardex.articleId}</td>
                  <td>{cardex.productCode}</td>
                  <td>{cardex.productName}</td>
                  <td>{cardex.remain}</td>
                  <td>{cardex.inQuantity}</td>
                  <td>{cardex.outQuantity}</td>
                  <td>{cardex.remain + cardex.inQuantity - cardex.outQuantity}</td>
                  <td>{cardex.providerName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش گردش انبار با مشتری.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn key={'productCode'} field={'productCode'} title={'بارکد'} />

              <gridColumn key={'productName'} field={'productName'} title={'نام محصول'} />

              <gridColumn key={'remain'} field={'remain'} title={'موجودی از قبل'} />
              <gridColumn key={'inQuantity'} field={'inQuantity'} title={'وارد شده'} />
              <gridColumn key={'outQuantity'} field={'outQuantity'} title={'خارج شده'} />
              <gridColumn key={'mandeh'} field={'mandeh'} title={'مانده'} />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            {this.dynamicBreadTitle()}
            <li>لیست گردش انبار با مشتری</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/warehouseIO'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={(manualDateMin) => this.setState({manualDateMin})}
                  onChangeToDate={(manualDateMax) => this.setState({manualDateMax})}
                  fromLabel="تاریخ دستی از"
                  toLabel="تاریخ دستی تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={(confirmDateMin) => this.setState({confirmDateMin})}
                  onChangeToDate={(confirmDateMax) => this.setState({confirmDateMax})}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="confirmFrom"
                  toId="confirmTo"
                />

                <div className="formComponent">
                  <label>کد محصول:</label>
                  <input className="form-control" type="text" id="articleId" />
                </div>

                <div className="formComponent">
                  <label>بارکد محصول:</label>
                  <input className="form-control" type="text" id="productCode" />
                </div>

                <div className="formComponent">
                  <label>نام کالا:</label>
                  <input className="form-control" type="text" id="productName" />
                </div>

                <div className="formComponent">
                  <label>نام انبار:</label>
                  <Select
                    value={this.state.typeWarehouseId}
                    onChange={(typeWarehouseId) => this.setState({typeWarehouseId})}
                    options={this.state.wareHousesname}
                    isMulti={false}
                    isClearable={true}
                    id="refTypeWarehouseId"
                    placeholder=""
                  />
                </div>

                <div className="formComponent">
                  <label>نوع انبار </label>
                  <select className="form-control" id="typePrimary" name="typePrimary">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div className="formComponent">
                  <label> بین انباری:</label>
                  <select className="form-control" id="isInternal">
                    <option value={false}>خیر</option>
                  </select>
                </div> */}

                <div className="formComponent">
                  <label> نوع ثبت:</label>
                  <select className="form-control" id="isAutomatic">
                    <option value="">------</option>
                    <option value={true}>اتوماتیک</option>
                    <option value={false}>دستی</option>
                  </select>
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده کالا"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>نام تامین کننده کالا:</label>
                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={this.state.providers}
                    isMulti={false}
                    isClearable={true}
                    id="providerId"
                    placeholder=""
                  /> */}
                </div>

                {/* <div className="formComponent">
                  <label>نوع طرف </label>
                  <select
                    className="form-control"
                    id="refType"
                    name="refType"
                    onChange={(e) => this.setState({ refType: e.target.value })}
                  >
                    <option value="CUSTOMER">مشتری</option>
                  </select>
                </div> */}

                {/* <div className="formComponent">
                  <label>نام انبار طرف:</label>
                  <Select
                    value={this.state.refTypeWarehouseId}
                    onChange={(refTypeWarehouseId) =>
                      this.setState({ refTypeWarehouseId })
                    }
                    options={this.state.wareHousesname}
                    isMulti={false}
                    isClearable={true}
                    id="refTypeWarehouseId"
                    placeholder=""
                  />
                </div> */}

                {/* <div className="formComponent">
                  <label>نوع انبار طرف </label>
                  <select
                    className="form-control"
                    id="refTypePrimaryWarehouseId"
                    name="refTypePrimaryWarehouseId"
                  >
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div> */}

                {/* <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده طرف سند"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.refProviderId}
                    setValue={(refProviderId) =>
                      this.setState({ refProviderId })
                    }
                  />
        
                </div> */}

                <div className="formComponent">
                  <label>شماره فاکتور طرف: </label>
                  <input className="form-control" type="text" id="refFactorNo" />
                </div>

                <div className="formComponent">
                  <label>مشتری طرف‌: </label>
                  <input className="form-control" type="text" id="refCustomerId" />
                </div>

                <div className="formComponent">
                  <label> نوع گردش:</label>
                  <select className="form-control" id="bigger">
                    <option value="">------</option>
                    <option value={'in'}>دارای مقدار وارده</option>
                    <option value={'out'}>دارای مقدار صادره</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.Io.map((cardex, index) => (
                  <tr key={index}>
                    <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                    <td>{cardex.articleId}</td>
                    <td>{cardex.productCode}</td>
                    <td>
                      <a target="_blank" href={productShop({articleId: cardex.articleId})}>
                        {cardex.productName}
                      </a>
                    </td>
                    {/*<td>{cardex.warehouseName}</td>*/}
                    <td>{cardex.remain}</td>
                    <td>{cardex.inQuantity}</td>
                    <td>{cardex.outQuantity}</td>
                    <td>{cardex.remain + cardex.inQuantity - cardex.outQuantity}</td>
                    {/*<td>{cardex.globalOperationNo}</td>*/}
                    <td>{cardex.providerName}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="5" />
                  <td>{this.state.totalInQuantity !== 0 && this.state.totalInQuantity}</td>
                  <td>{this.state.totalOutQuantity !== 0 && this.state.totalOutQuantity}</td>
                  <td>
                    <span />
                    {this.state.remainSum + this.state.totalInQuantity - this.state.totalOutQuantity !== 0 &&
                      (this.state.remainSum + this.state.totalInQuantity - this.state.totalOutQuantity).toFixed(2)}
                  </td>
                  <td colSpan="1" />
                </tr>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthCardex}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CustomerIo
